<script>
  import MenuTrigger from "$lib/components/MenuTrigger.svelte";
  import Link from "$lib/components/Link.svelte";
  import ResponsiveColumn from "$lib/components/ResponsiveColumn.svelte";
  import Icon from "$lib/components/Icon.svelte";

  export let data;
  export let isOpen = false;

  let label = data.fields.headerText || data.fields.text || data.fields.name;
  let menuLabelId = `menu-label-${data.sys.id}`;
</script>

<ResponsiveColumn>
  <div class="my-3">
    <MenuTrigger {data} on:click {isOpen} />
    <h3 class="sr-only" id={menuLabelId}>{label}</h3>

    {#if data.children}
      <ul class="list-none flex" aria-labelledby={menuLabelId}>
        {#each data.children as child}
          <li>
            <Link
              url={child.destination?.fields.url}
              class="!no-underline !font-normal flex !pl-0 !pr-16"
            >
              <span class="sr-only">{child.name}</span>
              {#if child.iconType}
                <Icon type={child.iconType} class="text-black" />
              {/if}
            </Link>
          </li>
        {/each}
      </ul>
    {/if}
  </div>
</ResponsiveColumn>
